/*
 * Session token storage for reconnect-within-grace-window.
 *
 * sessionStorage (not localStorage) is intentional: the token only matters
 * within the 30-second disconnect grace window (DISCONNECT_GRACE_MS), and
 * sessionStorage survives tab reloads but not the user closing the tab and
 * coming back hours later — which is exactly the window the token is valid for.
 */

const KEY = 'fernhollow-session';

export function readSessionToken(): string | null {
  try {
    return window.sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function writeSessionToken(token: string): void {
  try {
    window.sessionStorage.setItem(KEY, token);
  } catch {
    /* private browsing / quota — silently drop */
  }
}

export function clearSessionToken(): void {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    /* nothing to do */
  }
}
